import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('user', '/users')
const reducer = generator.generate()

export default reducer
